import React from 'react'
import styled from 'styled-components'

import Container from '../../components/Container'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'

const Component = styled.div`
  border-top: 1px solid rgba(255, 255, 255, .15);
  padding: 2rem 0;

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0;
  }
`

const Content = styled.div`
`

const Description = styled.div`
  color: rgba(255, 255, 255, .5);
  margin: .5rem 0 2rem 0;
`

const Inner = styled.div`
  color: rgba(255, 255, 255, .5);

  ${MEDIA_QUERY_DESKTOP} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 4rem;
  }

  h4 {
    color: white;
    margin-bottom: .5rem;
  }
`

const Title = styled.h2``

const Primary = styled.div``
const Secondary = styled.div``

const Concept = () => {
  return (
    <Component>
      <Container>
        <Content>
          <Title>
            Triptcip
          </Title>
          <Description>
            Triptcip is divided into two parts: Collections and Objects.
          </Description>
          <Inner>
            <Primary>
              <h4>
                Collections
              </h4>
              Collections are released in collaboration with artists, featuring full track, exclusive NFTs called Sequences, made with VOID synthesized visuals.
              <br />
              <br />
              Sequences are auctioned on our website à la Foundation style.
              <br />
              <br />
              <h4>
                Objects
              </h4>
              Objects are the life-blood of Triptcip's creative economy: one-shot audio visuals made by Triptcip creators, with curated audio from artists we collaborate with.
              <br />
              <br />
              Only holders are allowed to access VOID and list their creations on Triptcip Marketplace.
              <br />
              <br />
            </Primary>
            <Secondary>
              <h4>
                Community
              </h4>
              We host monthly VOID contests with generous prizes, invite top artists to talk about art, music, entrepreneurship, crypto, NFTs and more. Most of all, we all share a common passion around NFTs, visual art, audio and music production.
              <br />
              <br />
              We also believe in giving power to the community which is why VOID features are decided through governance with proposals and voting.
              <br />
              <br />
              Creating meaningful community engagement is one of our top priorities.
            </Secondary>
          </Inner>
        </Content>
      </Container>
    </Component>
  )
}

export default Concept
